var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_10114_24411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.23094 13.3303C4.33094 14.3903 7.04094 17.0403 9.69094 19.4803L9.94094 19.7103L10.1709 19.8703C10.5409 20.1003 10.6609 20.0103 11.0109 19.7603C11.5409 19.3703 11.4709 19.4603 11.8209 18.9003C11.9609 18.6803 12.0409 18.4103 11.9809 18.1503C11.9209 17.8803 11.8609 17.8003 11.6809 17.6103C11.4809 17.4203 9.25094 15.2503 5.36094 11.0403C5.36094 11.0403 3.41094 8.83029 5.53094 7.54029C9.07094 5.39029 11.0709 4.81029 12.6109 4.00029C12.8709 3.86029 12.9809 3.68029 12.9809 3.60029C13.0109 3.42029 13.0409 3.06029 12.9409 2.76029C12.6809 2.00029 12.1309 1.65029 11.6109 1.05029C11.2809 0.66029 11.1709 0.49029 10.7309 0.740289C8.49094 1.98029 3.58094 4.51029 2.75094 4.99029C-0.839057 7.03029 0.930943 11.1003 3.24094 13.3403L3.23094 13.3303Z",
    fill: "#DDD7D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10114_24411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.31,
    height: 19.39,
    fill: "white",
    transform: "translate(13 20) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDisable);
export default __webpack_public_path__ + "static/media/arrow-left-disable.0a62c3b161d5d22191163dde904279e0.svg";
export { ForwardRef as ReactComponent };